import { useBarcode } from 'react-barcodes';
export default function Barcode(props) {
  const { inputRef } = useBarcode({
    value: props.value,
    options: {}
  });

  return  <svg ref={inputRef} />
}